module.exports = __webpack_public_path__ + "files/9179a51ee4c8092bfd05e0f7790a2bbd.png";